var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdmLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.3062V18.4668L4.30534 22L22 7.11349V0L4.30534 14.8394L0 11.3062Z",
    fill: "#2A333E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.3047L13.6731 18.4653L17.8838 21.9985L22 18.4653V11.3047Z",
    fill: "#2A333E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.87796V0L8.46879 7.11349L4.30534 10.6467L0 6.87796Z",
    fill: "#2A333E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdmLogoIcon);
export default __webpack_public_path__ + "static/media/mdm-logo-icon.18e362bb3d8fa92e205c50d68a3ea806.svg";
export { ForwardRef as ReactComponent };